export const NAV = [
  { id: 'dashboard', label: 'Autopilot', icon: 'autopilot' },
  {
    id: 'posts',
    label: 'Posts',
    icon: 'grid',
    children: [
      { id: 'create', label: 'Create', icon: 'plus' },
      { id: 'content', label: 'Library', icon: 'grid' },
      { id: 'scheduler', label: 'Calendar', icon: 'calendar' },
    ],
  },
  { id: 'brand', label: 'Content Plan', icon: 'sparkles' },
  { id: 'help', label: 'Help Center', icon: 'help' },
  { id: 'settings', label: 'Settings', icon: 'settings' },
];
